module.exports = __webpack_public_path__ + "static/img/main_visual.104d934.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main_visual.jpg
// module id = tPX5
// module chunks = 34